import React, {Component} from "react";
import Table from "../../components/Table";
import MigrationItem from "./MigrationItem";
import EmptyStatus from "../../components/EmptyStatus";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {fromJS, List} from "immutable";
import {Query} from "react-apollo";
import gql from "graphql-tag";

class MigrationList extends Component {

  render() {
    let tableHeader = List([
      "Customer Id",
      "Name",
      "Email",
      "Active Subs",
      "Status"
    ])      
    let filters = {
      status: this.props.statusFilter,
      subscriptions: this.props.subscriptionFilter
    }        
    return (
      <Query query={MIGRATIONS} variables={filters}>
        {({ loading, error, data }) => {
          if (loading) return <Loading />
          if (error) return <GraphQLErrors error={error} />
          let migrations = fromJS(data.migrations);
          if (migrations.size === 0) {
            return <EmptyStatus status="No migrations" />
          }
          return (
            <Table 
              data={migrations} 
              mode="table"
              renderer={MigrationItem} 
              tableHeader={tableHeader}
              onItemClick={this.handleItemClick.bind(this)}
              selected={this.props.selectedCustomerId}
              showCount={true}
              itemKey="customerId"
              />
          )
        }}
      </Query>
    )
  }

  handleItemClick(itemData, e, field = "") {
    let id = itemData.get("customerId");
    this.props.onSelectionChange(id);
  }  


}

const MIGRATIONS = gql`
  query migrations($status:String, $subscriptions:String) {
    migrations(status: $status, subscriptions: $subscriptions) {
      customerId
      name
      email
      status
      subsActive
    }
  }
`

export default MigrationList;